import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/JWTAuthContext';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { signIn, user, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  useEffect(() => {
    if (!loading && user) {
      navigate('/', { replace: true });
    }
  }, [user, loading, navigate]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="login-container">
        <div className="login-content">
          <div className="login-logo-section">
            <div className="logo-container-large">
              <img src="/Logo.png" alt="Al Rugaib Logo" className="login-logo" />
            </div>
            <h1 className="login-brand-title">Reviews Hub</h1>
            <p className="login-brand-subtitle">Google Maps Analytics</p>
          </div>
          <div className="login-divider"></div>
          <div className="login-form-section">
            <div className="login-form-container">
              <div className="loading-spinner"></div>
              <p>Checking authentication...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const result = await signIn(email, password);

      if (result.success) {
        // Redirect to dashboard using React Router
        navigate('/', { replace: true });
      } else {
        setError(result.error || 'Authentication failed');
      }
    } catch (err) {
      setError('An unexpected error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        {/* Left Side - Logo Section */}
        <div className="login-logo-section">
          <div className="logo-container-large">
            <img src="/Logo.png" alt="Al Rugaib Logo" className="login-logo" />
          </div>
          <h1 className="login-brand-title">Reviews Hub</h1>
          <p className="login-brand-subtitle">Google Maps Analytics</p>
        </div>

        {/* Vertical Divider */}
        <div className="login-divider"></div>

        {/* Right Side - Form Section */}
        <div className="login-form-section">
          <div className="login-form-container">
            <h2 className="login-title">Sign In</h2>
            <p className="login-subtitle">Welcome back to your dashboard</p>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email" className="form-label">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter your email"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password" className="form-label">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter your password"
                  className="form-input"
                />
              </div>

              {error && (
                <div className="error-message">
                  {error}
                </div>
              )}

              <button 
                type="submit" 
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <div className="loading-spinner"></div>
                    Signing In...
                  </>
                ) : (
                  'Sign In'
                )}
              </button>
            </form>

            <div className="login-footer">
              <p>
                Need access? Contact your administrator to create an account.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;